export default __webpack_public_path__ + "static/media/Path426@2x.2eece23d.png";